import { useEffect, useMemo, useState } from "react";

const ORANGE = "#FF5722";
const KEY = "#7DD3FC";
const STR = "#A5D6A7";
const PUNCT = "#A1A1AA";

const buildTokens = (lang) => [
  { t: "const ", c: ORANGE },
  { t: "developer", c: "#FFFFFF" },
  { t: " = {\n", c: PUNCT },
  { t: "  name", c: KEY },
  { t: ": ", c: PUNCT },
  { t: '"İbrahim Şişman"', c: STR },
  { t: ",\n", c: PUNCT },
  { t: "  role", c: KEY },
  { t: ": ", c: PUNCT },
  { t: '"Full Stack Web Developer"', c: STR },
  { t: ",\n", c: PUNCT },
  { t: "  stack", c: KEY },
  { t: ": [", c: PUNCT },
  { t: '"React"', c: STR },
  { t: ", ", c: PUNCT },
  { t: '".NET"', c: STR },
  { t: ", ", c: PUNCT },
  { t: '"PostgreSQL"', c: STR },
  { t: "],\n", c: PUNCT },
  { t: "  devops", c: KEY },
  { t: ": [", c: PUNCT },
  { t: '"GitHub Actions"', c: STR },
  { t: ", ", c: PUNCT },
  { t: '"IIS"', c: STR },
  { t: "],\n", c: PUNCT },
  { t: "  aiTools", c: KEY },
  { t: ": [", c: PUNCT },
  { t: '"Claude"', c: STR },
  { t: ", ", c: PUNCT },
  { t: '"Codex"', c: STR },
  { t: ", ", c: PUNCT },
  { t: '"Gemini"', c: STR },
  { t: "],\n", c: PUNCT },
  { t: lang === "tr" ? "  kahve" : "  coffee", c: KEY },
  { t: ": ", c: PUNCT },
  { t: "Infinity", c: ORANGE },
  { t: ",\n", c: PUNCT },
  { t: "};", c: PUNCT },
];

export const CodeCard = ({ lang }) => {
  const chars = useMemo(() => {
    const out = [];
    buildTokens(lang).forEach((tok) => {
      for (const ch of tok.t) out.push({ ch, c: tok.c });
    });
    return out;
  }, [lang]);
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
    const id = setInterval(() => {
      setCount((n) => {
        if (n >= chars.length) {
          clearInterval(id);
          return n;
        }
        return n + 1;
      });
    }, 20);
    return () => clearInterval(id);
  }, [chars]);

  return (
    <div data-testid="hero-code-card" className="border border-[#1F1F1F] bg-[#0A0A0A]/80 backdrop-blur-md w-full max-w-md">
      <div className="flex items-center gap-2 px-4 py-3 border-b border-[#1F1F1F]">
        <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]" />
        <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]" />
        <span className="ml-3 font-mono text-[10px] tracking-widest text-zinc-500">developer.js</span>
      </div>
      <pre className="p-5 font-mono text-xs md:text-[13px] leading-relaxed whitespace-pre-wrap min-h-[230px]">
        {chars.slice(0, count).map((c, i) => (
          <span key={i} style={{ color: c.c }}>{c.ch}</span>
        ))}
        <span className="cursor-blink" style={{ color: ORANGE }}>▍</span>
      </pre>
    </div>
  );
};
